import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  fetchEvent,
  updateEvent,
  openInterestModal,
  fetchUserInterests,
  chatInvitesStatus,
  updateChatthreadRequest,
} from "ActionsMessage";
import { showError, showSuccess } from "ReduxErrorBar";
import ContentIcon, { HEADING_MESSAGES } from "ContentIcon";
import {
  COMMON_FAIL_MESSAGE,
  MAX_INTEREST_COUNT,
  DEVELOPMENT_TYPE,
  screenHeightLeftFromTop,
} from "Constants";
import InterestTag from "./interest-tag.js";
import InfoTutorial from "InfoTutorial";
import Loader from "Loader";
import LocaleStrings from "Languages";

class Messages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      executed: false,
      loading: true,
      desc: LocaleStrings.preparingMessages,
    };
    this.props.fetchUserInterests(this.props.session);
  }

  componentDidMount() {
    if (this.props.contentAvailable) {
      this.props.fetchEvent(this.props.session, (callback) => {
        this.setState({ loading: false });
      });
    } else {
      this.props.history.push("/dashboard/content");
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.contentAvailable !== this.props.contentAvailable) {
      if (nextProps.contentAvailable && !this.state.executed) {
        this.setState({ executed: true });
        this.props.fetchEvent(this.props.session, (callback) => {
          this.setState({ loading: false });
        });
      } else {
        this.props.history.push("/dashboard/content");
      }
    }
  };

  handleSwitch = (elem) => {
    var action = elem.currentTarget.checked ? 1 : 0;

    this.props.updateEvent(
      this.props.session,
      { messagestatus: action },
      (result) => {
        this.props.showSuccess("Message status updated successfully!");
      },
      (error) => {
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    );
  };

  addInterest = () => {
    this.props.openInterestModal(true);
  };

  renderTags = () => {
    return this.props.interestData.map((tag, index) => (
      <InterestTag key={index} tag={tag} />
    ));
  };

  changeChatInvitesStatus = () => {
    var { session, eventData } = this.props;
    let chatStatus = 0;
    let message = "Chat invites option deactivated.";
    if (eventData && eventData.chatinvites == 0) {
      chatStatus = 1;
      message = "Chat invites option activated.";
    }

    this.props.chatInvitesStatus(session, chatStatus, (response) => {
      if (response.success) {
        if (chatStatus == 0) {
          this.props.updateChatthreadRequest(session);
        }
        this.props.showSuccess(message);
      } else {
        this.props.showError("Something went wrong.");
      }
    });
  };

  render() {
    let { deviceSize } = this.props;
    var messagestatus = false;
    let chatInvitesChecked = false;

    if (this.props.eventData !== undefined) {
      messagestatus = this.props.eventData.messagestatus === 1 ? true : false;
    }

    if (this.props.eventData && this.props.eventData.chatinvites == 1) {
      chatInvitesChecked = true;
    }

    return (
      <div>
        <div className="content-header-bar">
          <div className="pull-left h-100 vertical-align-center">
            <ContentIcon heading={HEADING_MESSAGES} />
          </div>
          <div
            className="pull-right h-100 vertical-align-center content-end"
            style={{ marginLeft: "auto" }}
          >
            <InfoTutorial video="messages.mp4" />
          </div>
        </div>
        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            /* <div>
            <div className="row" style={{ paddingBottom: 4 }}>
              <div className="col-sm-8 col-lg-9">
                <div>
                  <div className="interest-title">User Interests</div>
                  <div className="interest-subtitle">
                    {DEVELOPMENT_TYPE === "koachify"
                      ? "This allows users to easliy find other users/courses having similar interests/tags"
                      : "This allows users to easily find other users having similar interests"}
                  </div>
                  <div className="interest-subtitle-info">{`Note - Maximum of ${MAX_INTEREST_COUNT} interests allowed to be added`}</div>
                </div>
              </div>
              <div className="col-sm-4 col-lg-9" style={{ paddingTop: 12 }}>
                <Button
                  
                  type="button"
                  className="btn btn-custom-blue"
                  onClick={this.addInterest}
                >
                  Manage Tags
                </Button>
              </div>
            </div> */
            /* <div className="row">
              <div className="col-md-8" ></div>
              <div className="col-md-4" >
                <div style={{display:'flex',  paddingRight: 16}}>
                  <div style={{fontWeight: 700, paddingTop: 8}}>Force Attendee Chat Invites</div> &nbsp;&nbsp;
                  <label className="poll-switch" style={{marginTop: 5}}>
                      <input type="checkbox" onChange={this.changeChatInvitesStatus} checked={checked}/>
                      <span className="poll-slider poll-round"></span>
                  </label>
                </div>
              </div>
            </div> */
            /* <div className="h-divider"></div>
            <div className="clearfix"></div>
            <div style={{ paddingTop: 15, paddingBottom: 4 }}>
              {this.renderTags()}
            </div>
            <AddInterests />
          </div>
          <div className="clearfix"></div>
          <div className="h-divider"></div>
          <div className="clearfix"></div> */
            <div className="row" style={{ paddingTop: 15, paddingBottom: 4 }}>
              <div className="col-md-9">
                <div>
                  <div className="interest-title">
                    {LocaleStrings.message_interest_title}
                  </div>
                  {/* <div className="interest-subtitle">
                    Choose if your attendees can message one another directly or
                    request an invite before messaging.
                  </div> */}
                  <div className="interest-subtitle-info">
                    {LocaleStrings.message_interest_subtitle_info}
                  </div>
                </div>
              </div>
              <div className="col-md-3" style={{ paddingTop: 12 }}>
                <div style={{}}>
                  <label
                    className="poll-switch"
                    style={{ margin: "0 2%", marginTop: 5 }}
                  >
                    <input
                      type="checkbox"
                      onChange={this.changeChatInvitesStatus}
                      checked={chatInvitesChecked}
                    />
                    <span className="poll-slider poll-round"></span>
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var availableFeatures = state.availableFeatures.filter(
    (feature) => feature.available
  );
  var selectedFeature = availableFeatures.filter(
    (feature) => feature.bsClass === state.selectedContentFeature.bsClass
  );
  var contentAvailable = selectedFeature.length > 0;
  var interestData = [];
  if (state.interests) {
    state.interests.map((interest, index) => {
      var interestObj = { ...interest, value: interest.interest };
      interestData.push(interestObj);
    });
  }

  return {
    session: state.session,
    deviceSize: state.deviceSize,
    eventData: state.eventData[0],
    contentAvailable,
    interests: state.interests,
    interestData,
  };
}

export default connect(mapStateToProps, {
  fetchEvent,
  updateEvent,
  openInterestModal,
  fetchUserInterests,
  chatInvitesStatus,
  showError,
  showSuccess,
  updateChatthreadRequest,
})(Messages);
